module.exports = __webpack_public_path__ + "manifest.json";


/*****************
 ** WEBPACK FOOTER
 ** ./app/static/manifest.json
 ** module id = 932
 ** module chunks = 0
 **/